import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CommonSearchCriteria from '../../../common/CommonSearchCriteria';
import CommonLoader from '../../../common/CommonLoader';
import SlatesTable from './SlatesTable';
import { GetTestSlates } from '../../../../services/TestLibService';
import { NotificationManager } from 'react-notifications';

const Slates = () => {
  const statusList = ['Active', 'InActive'];

  const [loading, setLoading] = useState(false);
  const [slatesData, setSlatesData] = useState([]);
  const [slatesCount, setSlatesCount] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState({
    searchText: '',
    orderStatus: 'Active',
    startDate: '',
    endDate: '',
    pageNumber: 0,
    pageSize: 10,
  });

  useEffect(() => {
    const today = new Date();
    const startDateValue = new Date(today);
    startDateValue.setDate(today.getDate() - 15);
    const endDateValue = new Date(today);
    endDateValue.setDate(today.getDate() + 15);

    const initialCriteria = {
      searchText: '',
      orderStatus: '',
      startDate: startDateValue.toISOString().split('T')[0],
      endDate: endDateValue.toISOString().split('T')[0],
      pageNumber: 0,
      pageSize: 10,
    };

    setSearchCriteria(initialCriteria);
    if (isValidSearchCriteria(initialCriteria)) {
      getSlates(initialCriteria);
    }
  }, []);

  const isValidSearchCriteria = (criteria) =>
    criteria.orderStatus !== '' || criteria.startDate !== '' || criteria.endDate !== '';

  const getSlates = async (criteria) => {
    if (criteria.startDate === '' || criteria.endDate === '') return;
    try {
      setLoading(true);
      const response = await GetTestSlates(
        criteria.startDate,
        criteria.endDate,
        criteria.orderStatus,
        criteria.searchText,
        criteria.pageNumber,
        criteria.pageSize
      );
      setSlatesData(response.results);
      setSlatesCount(response.count);
    } catch (err) {
      NotificationManager.error('Error getting slates. ' + err, 'Error');
    } finally {
      setLoading(false);
    }
  };

  const handleSearchCriteria = (changedSearchCriteria) => {
    const updated = {
      ...searchCriteria,
      startDate: changedSearchCriteria.startDate,
      endDate: changedSearchCriteria.endDate,
      orderStatus: changedSearchCriteria.orderStatus,
      searchText: changedSearchCriteria.searchText,
      pageNumber: 0,
    };
    setSearchCriteria(updated);
    getSlates(updated);
  };

  const onChangePageSettings = (pageNumber, pageSize) => {
    const updated = { ...searchCriteria, pageNumber, pageSize };
    setSearchCriteria(updated);
    getSlates(updated);
  };

  return (
    <div className="vlp-component-container">
      <span className="title">Test Slate Management</span>
      <hr />
      <div className="columns">
        <div className="column">
          <CommonSearchCriteria
            orderStatusOptions={statusList}
            onSearch={handleSearchCriteria}
            extraActions={
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<AddIcon />}
                style={{ height: "40px", whiteSpace: "nowrap" }}
                onClick={() => window.open("/vlp/maintenance-test-slate/add", "_blank")}
              >
                New
              </Button>
            }
          />
        </div>
      </div>
      <SlatesTable slatesData={slatesData} count={slatesCount} onChange={onChangePageSettings} />
      <CommonLoader loading={loading} />
    </div>
  );
};

export default Slates;
